import React from 'react'

import { Pressable, XStack } from '@zet/design-system'

import BackIcon from '../../assets/icons/Back'
import EditIcon from '../../assets/icons/EditIcon'
import useJPBBridge from '../../hooks/useJPBBridge'
import { sendAnalyticsData } from '../../utils/analyticsEvents'
import { B14 } from '../typography'

export const IntegrationFlowHeader = ({
  setShowEditBasicDetailsSheet,
}: {
  setShowEditBasicDetailsSheet?: (arg: boolean) => void
}) => {
  const { goBack } = useJPBBridge()
  const handleOnPress = () => {
    goBack()
  }

  const handleShowEditBasicDetailsSheet = () => {
    setShowEditBasicDetailsSheet?.(true)
    sendAnalyticsData({ type: 'click', screen: 'EDITDETAIL_CTA' })
  }

  return (
    <XStack className="items-center justify-between bg-white">
      <Pressable className="bg-white p-3" onPress={handleOnPress}>
        <BackIcon />
      </Pressable>
      {setShowEditBasicDetailsSheet && (
        <Pressable
          className="m-3 select-none flex-row items-center rounded-full bg-[#EBECEF] px-3 py-2"
          onPress={handleShowEditBasicDetailsSheet}
        >
          <EditIcon />
          <B14 className="ml-2 font-bold">{'Edit details'}</B14>
        </Pressable>
      )}
    </XStack>
  )
}
